module.exports = __webpack_public_path__ + "img/arrival_7.64dfabad.jpg";